<section class="top">
  <div class="cover">
    <h2>{{ "collections-top.page-title" | translate}}</h2>
    <div class="cover-image">
      <img src="/assets/images/collectionsPage/salescover.png">
    </div>
  </div>
</section>